module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-Semibold-b9298609941382e8ee976dd0f5c6d72a.woff";